import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  color: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#141B34",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M19.5 11c0-.818 0-1.57-.152-1.937s-.441-.657-1.02-1.235l-4.736-4.736c-.499-.499-.748-.748-1.058-.896a2 2 0 0 0-.197-.082C12.014 2 11.661 2 10.956 2c-3.245 0-4.868 0-5.967.886a4 4 0 0 0-.603.603C3.5 4.59 3.5 6.211 3.5 9.456V14c0 3.771 0 5.657 1.172 6.828S7.729 22 11.5 22h8m-7-19.5V3c0 2.828 0 4.243.879 5.121C14.257 9 15.672 9 18.5 9h.5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M13.5 14v3c0 .943 0 1.414.293 1.707S14.557 19 15.5 19M8 14l1.5 2.5m0 0L11 19m-1.5-2.5L11 14m-1.5 2.5L8 19M20.5 14H19a1 1 0 0 0-1 1v.5a1 1 0 0 0 1 1h.5a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1H18"
    }, null, -1)
  ]))]))
}
export default { render: render }